import React, { useState, Suspense, lazy, useEffect } from 'react';
import ClientNavBar from '../../components/navbar/partner/ClientNavBar';
import image4 from '../../images/Resort.png'; // Ensure the path to the image is correct
import TabNavigation from '../../components/PartnerAdmin/TabNavigation';
import { jwtDecode } from 'jwt-decode';
import { useParams, useNavigate } from 'react-router-dom';

const Dashboard = lazy(() => import('../../components/PartnerAdmin/Dashboard/DashboardVenue'));
const About = lazy(() => import('../../components/PartnerAdmin/about/About'));
const Products = lazy(() => import('../../components/PartnerAdmin/Products'));
const OrderHistory = lazy(() => import('../../components/PartnerAdmin/orderhistroy/OrderHistory'));
const SlotManagement = lazy(() => import('../../components/PartnerAdmin/SlotManagement'));
const Promotions = lazy(() => import('../../components/PartnerAdmin/Promotions'));
const VenueDetails = lazy(() => import('../../components/PartnerAdmin/about/VenueDetails'));


const getClientIdFromToken = () => {
  const token = localStorage.getItem('business_token');
  if (token) {
    try {
      const decoded = jwtDecode(token);
      const userData = JSON.parse(decoded.sub);
      return userData.client_id;
    } catch (error) {
      console.error('Error decoding token:', error);
    }
  }
  return null;
};

const PartnerAdminVenue = () => {
  const [currentTab, setCurrentTab] = useState('dashboard');
  const { clientid, venue, event, temple, org } = useParams(); // Destructure venueid
  const navigate = useNavigate();
  const authorizedClientId = getClientIdFromToken();
  const [productDetails, setProductDetails] = useState([]); // State to store product details
  
  const entityType = venue ? 'venue' : event ? 'event' : temple ? 'temple' : org ? 'org' : null;


  useEffect(() => {
    if (authorizedClientId !== clientid) {
      alert('Unauthorized access');
      navigate('/'); // Redirect to a safe page
    } else {
      // Fetch venue data only if the client is authorized
      const fetchVenueData = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_API_URL}/getbyvenueid?venueid=${'TRF2400000010'}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            setProductDetails(data.responseContent?.productDetails || []); // Extract productDetails
          } else {
            console.error('Failed to fetch venue data:', response.status);
          }
        } catch (error) {
          console.error('Error fetching venue data:', error);
        }
      };

      fetchVenueData();
    }
  }, [authorizedClientId, clientid,entityType, venue, event, temple, org]);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar (TabNavigation) */}
      <TabNavigation currentTab={currentTab} setCurrentTab={setCurrentTab} entityType={entityType}  />

      {/* Main Content Area with Left Margin */}
      <div className="flex-1 flex flex-col overflow-y-auto ml-64">
        {/* Navbar */}
        <ClientNavBar />

        {/* Image Section */}
        <div className="relative">
          <img
            src={image4}
            alt="Beautiful resort view"
            className="w-full h-32 object-cover"
          />
        </div>
        {/* Main Content */}
        <div className="flex-1 p-2">
          <div className="container mx-auto py-0">
            <Suspense fallback={<div>Loading...</div>}>
              {currentTab === 'dashboard' && <Dashboard />}
              {currentTab === 'about' && <About />}
              {currentTab === 'productUpdation' && (
                <Products productDetails={productDetails} venueid="TRF2400000010" client_id={clientid} />
              )}
              {currentTab === 'orderHistory' && <OrderHistory />}
              {currentTab === 'slotManagement' && <SlotManagement productDetails={productDetails}/>}
              {currentTab === 'promotions' && <Promotions productDetails={productDetails}/>}
              {currentTab === 'venueDetails' && <VenueDetails venueid="TRF2400000010"/>}
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerAdminVenue;
